export default __webpack_public_path__ + "static/fluentWorldsProduct-2aac6fe0fa723d0f0d53366683439ad0.png";